export class TCA{
    constructor(magn1, axis1, magn2, axis2, magn3, axis3) {
        this.magn1 = magn1;
        this.axis1 = axis1;
        this.magn2 = magn2;
        this.axis2 = axis2;
        this.magn3 = magn3;
        this.axis3 = axis3;
      }
}